import type { CreateMapiqMap } from "@map/mapiq-map-react/src/MapView";

/** Calls `create` once and keeps its result, so every map shares one import of each renderer. */
const once = <T>(create: () => T) => {
  let cached: T | null = null;

  return () => {
    if (cached === null || cached === undefined) {
      cached = create();
    }

    return cached;
  };
};

export const resolve2dRenderer = once(async (): Promise<CreateMapiqMap> => {
  const { createMapiqMap } = await import("@map/mapiq-map/MapiqMap");

  return ({ container, mapData, viewportRestriction, disablePointerEvents }) => {
    if (mapData.type !== "2d") throw new Error("Mismatched map resolved");

    return createMapiqMap(container, mapData.map, viewportRestriction, disablePointerEvents);
  };
});

export const resolve3dRenderer = once(async (): Promise<CreateMapiqMap> => {
  const { createMapiqMap3d } = await import("@map/mapiq-map/MapiqMap3d");

  return ({ container, mapData, disablePointerEvents }) => {
    if (mapData.type !== "3d") throw new Error("Mismatched map resolved");

    return createMapiqMap3d(container, mapData.map, disablePointerEvents);
  };
});
